<template>
  <a
    :href="link.url"
    :target="link.newWindow ? '_blank' : '_self'"
    :title="link.title"
  >
    <i
      :class="[link.icon, { noHover: noHover }]"
      :style="{ background: link.color }"
      v-on:mouseenter="noHover = false"
      v-on:mouseleave="noHover = true"
    >
    </i>
  </a>
</template>

<script>
export default {
  name: "SocialSharingLink",
  props: {
    link: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      noHover: true
    };
  }
};
</script>
